// Preserve asterisks used for data masking without changing regular Markdown
// emphasis or code spans. Escaped asterisks are supported for streamed data.
export const escapeMaskedAsterisks = text => {
  if (typeof text !== 'string' || !text.includes('*')) return text;

  const codeBlocks = [];
  const textWithoutCode = text.replace(/(`{1,3})([\s\S]*?)\1/g, code => {
    const placeholder = `<!--markdown-code-${codeBlocks.length}-->`;
    codeBlocks.push(code);
    return placeholder;
  });
  const escapedText = textWithoutCode.replace(
    /(?:(?<=[\p{L}\p{N}])(?:(?:\\\*)+|\*{2,})(?=[\p{L}\p{N}])|(?<![\\*])(?:\\?\*){4,}(?!\*))/gu,
    run => `<span data-mask-asterisk="true">${run.replace(/\\?\*/g, '&#42;')}</span>`
  );

  return escapedText.replace(
    /<!--markdown-code-(\d+)-->/g,
    (_, index) => codeBlocks[Number(index)]
  );
};
